<template>
  <div>
    <div class="d-flex flex-wrap align-items-end filters-row">
      <div class="flex-grow-1 filter-field">
        <b-form-group label="Estado" label-for="state" class="mb-0">
          <v-select
            id="state"
            :value="selectedStates"
            :options="regionOptions"
            multiple
            placeholder="Seleccione estados"
            label="label"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:selectedStates', val)"
          />
        </b-form-group>
      </div>

      <!--<div class="flex-grow-1 filter-field">
        <b-form-group label="Ciudad" label-for="city" class="mb-0">
          <v-select
            id="city"
            :value="selectedCity"
            :options="municipalityOptions"
            placeholder="Seleccione ciudad"
            multiple
            label="label"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:selectedCity', val)"
          />
        </b-form-group>
      </div>-->

      <div class="flex-grow-1 filter-field">
        <b-form-group label="Búsqueda" label-for="search" class="mb-0">
          <b-form-input
            id="search"
            :value="searchQuery"
            placeholder="Buscar por SIRH, ID Cajero, Municipio, Sucursal"
            @input="(val) => $emit('update:searchQuery', val)"
          />
        </b-form-group>
      </div>

      <div class="flex-grow-1 flex-md-grow-0">
        <b-button
          variant="primary"
          class="w-100"
          :disabled="loading"
          @click="$emit('add-installations')"
        >
          <feather-icon icon="PlusIcon" class="mr-25" />
          <span class="text-nowrap">Agregar</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select"

export default {
  name: "CrisisFormFilters",
  components: {
    vSelect,
  },
  props: {
    loading: {
      type: Boolean
    },
    regionOptions: {
      type: Array,
      default: () => [],
    },
    selectedStates: {
      type: Array,
      default: () => [],
    },
    municipalityOptions: {
      type: Array,
      default: () => [],
    },
    selectedCity: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: "",
    },
  },
}
</script>

<style lang="scss" scoped>
.filters-row {
  gap: 10px;
}

.filter-field {
  min-width: 230px;
  max-width: 100%;
}
</style>
